import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    CardImg,
    ButtonGroup,
    Button,
    Row,
    Modal,
    ModalHeader,
    CustomInput,
    InputGroupAddon,
    InputGroupText,
    Input,
    ModalBody,
    InputGroup
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
    Separator,
    Colxx,
} from '../../../../../../components/common/CustomBootstrap';

import {
    colorBlockStlye,
    editingStlyeWithoutBackGround,
    InputStlye,
    SelectStyle,
    setBackGroundColor,
} from '../../style/DigitalAssistantStyle';

import avatars from '../../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../../propinfo/gallery/index';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import { FontAwesome } from '@fortawesome/react-fontawesome';
import SettingsIcon from '@mui/icons-material/Settings';

import FontsList from './FontsList';

export default function SpaceStandaloneDigitalAssistant({
    isVoucher = false,
    botSettings,
    saveIntegration,
    integrationId,
    integration,
    propertyId,
    allProperties
}) {

    /** Avatar state */
    const [isSelected, setIsSelected] = useState({
        Jenni: false,
        Novi: false,
        Bob: false,
        Sarah: false,
        Wallis: false,
    });
    const [isAivaHide, setIsAivaHide] = useState(integration.isaivaHide || false);
    const [isFooterHide, setIsFooterHide] = useState(botSettings.isFooterHide !== undefined ? botSettings.isFooterHide : false);
    const [avatarLink, setAvatarLink] = useState('');
    const [avatarName, setAvatarName] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [arrowType, setArrowType] = useState(0);
    const [arrowSize, setArrowSize] = useState(40);
    const [font, setFont] = useState('');
    const [arrow, setArrow] = useState('');
    const [displayVouchers, setDisplayVouchers] = useState('');
    const [galleryVisible, setGalleryVisible] = useState(false);
    /** other Digital Assistant state */
    const [edit, setEdit] = useState(true);
    let [setting, setSetting] = useState(botSettings);
    const [error, setError] = useState(true);


    const [fontsList, setFontsList] = useState({
        'title': '',
        'subTitle': '',
        'voucherTitle': '',
        'voucherDescription': '',
        'website': '',
        'buttonText': '',
    });
    let [iseditMode, setEditMode] = useState({
        'title': false,
        'subTitle': false,
        'arrow': false,
        'primaryColor': false,
        'buttonColor': false,
        'redeemBar': false,
        'redeemButton': false,
        'bookButtonText': false,
        'redeemTextColor': false,
        'backgroundColor': false,
        'detailsButtonText': false,
    });
    useEffect(() => {
        if (botSettings) {
            setAvatarName(botSettings.title);
            setSubTitle(botSettings.subTitle);
            setAvatarLink(botSettings.icon);
            setFont(botSettings.font);
            setFontsList(botSettings.fonts);
            setArrowType(botSettings.arrowType);
            setArrowSize(botSettings.arrowSize);
            setDisplayVouchers(botSettings.displayVouchers);
            setIsSelected({ ...avatars, [botSettings.name]: true });
        }
    }, [botSettings]);

    useEffect(() => {
        if (setting) {
            setSetting({
                ...setting,
                urls: { ...setting.urls, icon: avatarLink },
            });
        }
    }, [avatarLink]);
    const RedirectToDemo = () => {
        var url = `${process.env.REACT_APP_BOT_DEMO
            }?gid=${getGroupID()}&iid=${integrationId}`;
        window.open(url, '_blank');
    };

    const handleColoursReset = () => {
        let colours = {
            title: 'black',
            'accentColor': 'black',
            primaryColor: '#E31B78',
            buttonColor: '#033DA5',
            redeemBar: '#FA8DAB',
            redeemButton: '#F5D2E3',
            bookButtonText: 'white',
            redeemTextColor: 'black',
            backgroundColor: '#ED187B',
            detailsButtonText: 'white'
        };
        setSetting({ ...setting, colours: colours });


    }

    const handleChange = (e) => {
        const value = e.target.value;
        setSetting({
            ...setting,
            [e.target.name]: value,
        });
    };

    const handleSave = () => {
        setEdit(!edit);
        setting.isFooterHide = isFooterHide == "true" ? true : false;
        setting.title = avatarName;
        setting.icon = avatarLink;
        setting.font = font;
        setting.isFooterHide = isFooterHide;
        setting.subTitle = subTitle;
        setting.arrowType = arrowType;
        setting.arrowSize = arrowSize;
        setting.fonts = fontsList;
        setting.displayVouchers = displayVouchers;
        saveIntegration({ pageSettings: setting, isaivaHide: isAivaHide });
    };

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setAvatarLink(image.src);
        setSetting({
            ...setting,
            name: image.caption,
        });
    };
    const SetClose = () => {
        setEditMode({
            'title': false,
            'accentColor': false,
            'arrow': false,
            'primaryColor': false,
            'buttonColor': false,
            'redeemBar': false,
            'redeemButton': false,
            'bookButtonText': false,
            'redeemTextColor': false,
            'backgroundColor': false,
            'detailsButtonText': false,
        });
    };
    const CloseColorBox = (event) => {
        if ((iseditMode.title === true || iseditMode.arrow === true ||
            iseditMode.accentColor === true || iseditMode.primaryColor === true || iseditMode.buttonColor === true || iseditMode.redeemBar === true
            || iseditMode.redeemButton === true || iseditMode.bookButtonText === true ||
            iseditMode.backgroundColor === true || iseditMode.detailsButtonText === true)) {
            SetClose();

        }
    };
    const handleAivaChange = (e) => {
        setIsAivaHide(e.target.checked);
    }
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    return (
        <Fragment>
            {botSettings ? (
                <Card>
                    <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
                        <div className="text-center">
                            <h6>Standalone Page Appearance</h6>
                            <Separator className="mb-3" />
                            <CardImg
                                top
                                src={avatarLink}
                                alt="Card image cap"
                                className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={togglegallery}
                                >
                                    Browse Logo
                                </Button>
                            </div>

                            <div className="my-2">
                                <b>Title</b>
                                <br />
                                <input
                                    name="title"
                                    style={InputStlye}
                                    defaultValue={botSettings.title}
                                    onChange={(e) => setAvatarName(e.target.value)}
                                />
                            </div>

                            <div className="mb-1">
                                <b>Subtitle</b>
                                <br />
                                <input
                                    name="subTitle"
                                    style={InputStlye}
                                    defaultValue={botSettings.subTitle}
                                    onChange={(e) => setSubTitle(e.target.value)}
                                />
                            </div>

                        </div>
                        <div className="text-left">
                            <div className="my-2 text-center"><b>Colour Settings</b></div>
                            <div style={{ padding: '0 5%' }}>


                                <Row>

                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Primary Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.primaryColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.primaryColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.primaryColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.primaryColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.primaryColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.primaryColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>

                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Accent Color</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.accentColor}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.accentColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, accentColor: !iseditMode.accentColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.accentColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.accentColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.accentColor}
                                                    name="accentColor"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.accentColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div></div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Background Color</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.backgroundColor}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.backgroundColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, backgroundColor: !iseditMode.backgroundColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.backgroundColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.backgroundColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.backgroundColor}
                                                    name="accentColor"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.backgroundColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div></div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Book Button Text Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.bookButtonText = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.bookButtonText}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, bookButtonText: !iseditMode.bookButtonText });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.bookButtonText)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.bookButtonText && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.bookButtonText}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.bookButtonText = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Details Button Text</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.detailsButtonText}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.detailsButtonText = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, detailsButtonText: !iseditMode.detailsButtonText });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.detailsButtonText)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.detailsButtonText && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.detailsButtonText}
                                                    name="accentColor"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.detailsButtonText = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div></div>}
                                    </Colxx>


                                </Row>
                            </div>

                            <div className="mb-1 text-center">


                                <div className="my-2 mt-3 text-center"><b>Font Settings</b></div>
                                <div className='row'>
                                    <div className="mb-1  row col-md-6 text-center">
                                        <div className="col-md-4" style={{ marginTop: '1.05rem' }}>
                                            <b>Website Font Name </b>
                                        </div>
                                        <br />
                                        <div className="col-md-8">
                                            <FontsList InputStlye={SelectStyle} value={botSettings.font} botSettings={botSettings} setFont={(e) => setFont(e.target.value)}></FontsList>
                                        </div>
                                    </div>
                                    {botSettings.fonts !== undefined && <Fragment>
                                        <div className="mb-1  row col-md-6 text-center">
                                            <div className="col-md-4" style={{ marginTop: '1.05rem' }}>
                                                <b>Title Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-8">
                                                <FontsList InputStlye={SelectStyle} value={botSettings.fonts.title} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, title: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                        <div className="mb-1 row  col-md-6 text-center">
                                            <div className="col-md-4" style={{ marginTop: '1.05rem' }}>
                                                <b>Subtitle Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-8">
                                                <FontsList InputStlye={SelectStyle} value={botSettings.fonts.subTitle} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, subTitle: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                        <div className="mb-1 row  col-md-6 text-center">
                                            <div className="col-md-4" style={{ marginTop: '1.05rem' }}>
                                                <b>Button Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-8">
                                                <FontsList InputStlye={SelectStyle} value={botSettings.fonts.buttonText} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, buttonText: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                        <div className="mb-1 row col-md-6 text-center">
                                            <div className="col-md-4" style={{ marginTop: '0.15rem' }}>
                                                <b>Space Title Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-8">
                                                <FontsList InputStlye={SelectStyle} value={botSettings.fonts.voucherTitle} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, voucherTitle: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                        <div className="mb-1 row  col-md-6 text-center">
                                            <div className="col-md-4" style={{ marginTop: '0.5rem' }}>
                                                <b>Space Description Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-8">
                                                <FontsList InputStlye={SelectStyle} value={botSettings.fonts.voucherDescription} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, voucherDescription: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </Fragment>}
                                </div>
                                <div className='d-flex justify-content-center my-3'>
                                    <CustomInput
                                        type="checkbox"
                                        id="aivaEnabled"
                                        checked={isAivaHide}
                                        name="aivaEnabled"
                                        onChange={handleAivaChange}
                                    >Replace the ebooking email from text to "{allProperties.filter((m) => m.id === propertyId)[0].name}", otherwise shows as "myma.ai"</CustomInput>
                                </div>
                                {/* <div className='d-flex justify-content-center my-3'>
                                    <CustomInput
                                        key="isFooterAiva"
                                        type="checkbox"
                                        checked={isFooterHide}
                                        onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                                    ><span>Hide "Grow with aiva"</span></CustomInput>
                                </div> */}
                                <div className='d-flex justify-content-center my-3'>
                                    <Button
                                        size="xs"
                                        color="dark"
                                        outline
                                        onClick={() => {
                                            handleColoursReset();
                                        }}
                                    >
                                        Reset to default font and colors
                                    </Button>
                                </div>
                            </div>
                            <Separator className="mt-2" />
                            <div className='text-center'>
                                <div className="mb-2 " style={{ marginTop: '40px' }}>
                                    <Button color="primary" size="xs" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Button className='ml-2'
                                        size="xs"
                                        color="secondary"
                                        onClick={() => {
                                            CloseColorBox();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card >
            ) : null
            }
            {ImageGalleryButton()}

        </Fragment >
    );
}

